exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".timer{margin:1rem 0;width:100%}.timer__progress{height:1rem;width:100%}.timer__p__over{background:#29d;height:100%;transition:all .1s ease}.timer__label{color:maroon}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Timer/timer.scss
// module id = 227
// module chunks = 0